export enum PeopleTabs {
  ABSENCES = 'PEOP_ABSENCES',
  BASIC = 'PEOP_BASIC',
  EQUIPMENT = 'PEOP_EQUIPMENT',
}

export enum DevelopmentTabs {
  EDUCATION = 'DEV_EDUCATION',
}

export enum RewardingTabs {
  GENERAL = 'REW_GENERAL',
  WORKTIME = 'REW_TIME_REPORTING',
}

export enum PerformanceTabs {
  GOALSETTING = 'PERF_GOAL_SETTING_REVIEW',
}
